<!--
 * @Author: Gaho
 * @Date: 2024-03-19 13:10:18
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 16:57:33
 * @Description: 
-->
<template>
    <div class="game-content" :class="{ animation: isAnimation }">
        <Button
            v-for="(v, k) in tableArray"
            :key="k"
            @click="$emit('changeSelectStatusFun', k)"
            :class="{
                'selected': v.status === 'selected' && !randomSeed.length,
                'result': randomSeed.length && !v.status,
                'win': v.status === 'selected' && ['0', '1', '2'].includes(randomSeed[k]),
                'win-0': v.status === 'selected' && randomSeed[k] === '0',
                'win-1': v.status === 'selected' && randomSeed[k] === '1',
                'win-2': v.status === 'selected' && randomSeed[k] === '2',
            }"
            :disabled="
                (tableArray.filter((item) => item.status === 'selected').length >= 3 &&
                !v.status &&
                !randomSeed.length) || isSubmiting
            "
        >
            <img v-if="randomSeed.length" :src="getImageUrl(randomSeed[k])" alt="" />
        </Button>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { getImageUrl } from '../../utils/index';
export default defineComponent({
    name: 'gameContent',
    props: {
        tableArray: {
            type: Array<any>,
            default: () => []
        },
        isAnimation: {
            type: Boolean,
            default: false
        },
        randomSeed: {
            type: Array<any>,
            default: () => []
        },
        isSubmiting:{
            type:Boolean,
            default:true
        }
    },
    methods: {
        getImageUrl
    }
});
</script>
<style lang="scss" scoped>
.game-content {
    display: grid;
    grid-template-columns: repeat(6, auto);
    width: 100%;
    margin: 0 6px;
    grid-gap: 5px;
    max-width: unset;
    transform: translateZ(0);
    button {
        align-items: center;
        background-color: #182337;
        border: 2px solid transparent;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        padding: 0;
        position: relative;
        width: 100%;
        &::after,
        &::before {
            content: '';
            display: block;
            pointer-events: none;
            user-select: none;
        }
        &::before {
            border-radius: 50%;
            filter: blur(6px);
            height: 60%;
            opacity: 0;
            position: absolute;
            visibility: hidden;
            width: 60%;
        }
        &::after {
            padding-bottom: 100%;
        }
        &:disabled {
            background-color: #182337;
            filter: brightness(0.85);
            cursor: not-allowed;
            opacity: 1 !important;
        }
        &:hover:not(.selected):not(.result):not(.win):not(:disabled) {
            background-color: #293a58;
        }
        img {
            width: 55%;
            user-select: none;
        }
    }
    .selected {
        background-color: #297fe5;
    }
    .result {
        opacity: 0.5;
    }
    .win {
        &::before {
            opacity: 0.67;
            visibility: visible;
        }
        img {
            transform: scale(1.15);
        }
    }
    .win-0 {
        border-color: #29e5ff;
        &::before {
            background-color: #00c2ff;
        }
    }
    .win-1 {
        border-color: #f93c3c;
        &::before {
            background-color: #ed1d49;
            height: 70%;
            width: 70%;
        }
    }
    .win-2 {
        border-color: #ffae4e;
        &::before {
            background-color: #ffda17;
        }
    }
}
.animation {
    button {
        img {
            opacity: 1;
            transform: scale(0);
            width: 55%;
        }
    }
    .result {
        opacity: 0.5;
        img {
            animation: example 1s cubic-bezier(0.3, 0.84, 0.45, 1.06) 0.3s 1 forwards;
            will-change: auto;
        }
    }
    .win {
        &::before {
            opacity: 0.67;
            visibility: visible;
        }
        img {
            animation: example 0.7s cubic-bezier(0.3, 0.84, 0.45, 1.06) 1 forwards;
        }
    }
}
@keyframes example {
    0% {
        filter: blur(2px) brightness(0);
        opacity: 1;
        transform: scale(0);
    }

    50% {
        filter: blur(0);
        transform: scale(1.2);
    }

    to {
        filter: brightness(1);
        opacity: 1;
        transform: scale(1.15);
    }
}
</style>